/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './user-copy-modal.component.html';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {UserResource} from '../../../components/api/resources/resource/user.resource';

export interface UserCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-user-copy-modal',
  template
})
export class UserCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<UserCopyResult>();

  originalName = '';
  username = '';
  name = '';
  displayName = '';
  password = '';
  destination = true;
  pending = false;
  validationErrors: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(UserResource) private readonly User: any,
    private readonly ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.displayName = nextCopyTitle(this.model?.displayName || '');
    this.username = '';
  }

  copy(): void {
    if (this.pending) {
      return;
    }

    this.pending = true;
    this.validationErrors = [];

    const copyData = _.cloneDeep(this.model);
    copyData.id = Uuid.generate();
    copyData.name = this.name;
    copyData.displayName = this.displayName;
    copyData.username = this.username;
    copyData.password = this.password;

    const copy = new this.User(copyData);
    copy.$save().then((saved: any) => {
      this.ngZone.run(() => {
        completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
      });
    }, (errors: any) => {
      this.ngZone.run(() => {
        this.validationErrors = (errors && errors.data && errors.data.errors) || [];
        this.pending = false;
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
